import client from './client';
import type { ApiResponse, User } from '../types';

interface LoginRequest {
  username: string;
  password: string;
}

interface LoginResponse {
  user: User;
  token: string;
}

export const authApi = {
  login: (data: LoginRequest) =>
    client.post<ApiResponse<LoginResponse>>('/login', data),

  logout: () =>
    client.post('/logout'),

  getProfile: () =>
    client.get<ApiResponse<User>>('/me'),

  resumeSession: () => client.get<ApiResponse<LoginResponse>>('/session'),

  changePassword: (data: {
    current_password: string;
    new_password: string;
    confirm_password: string;
  }) => client.post('/reset_password', data),

  resetApiKey: () =>
    client.post<ApiResponse<string>>('/reset'),
};
